import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router'
import { ErrorState } from '../components/States'
import './AppShell.css'

/** A screen failed to load or render (inside the shell). Says nothing was lost and offers a reload. */
export function RouteError() {
  const { t } = useTranslation()
  const error = useRouteError()

  useEffect(() => {
    // The name only: messages can carry figures someone typed.
    console.error('Screen failed:', error instanceof Error ? error.name : 'unknown error')
  }, [error])

  return (
    <div className="container screen">
      <title>{t('app.routeError.title')}</title>
      <ErrorState
        title={t('app.routeError.title')}
        body={t('app.routeError.body')}
        retryLabel={t('app.routeError.reload')}
        onRetry={() => window.location.reload()}
      />
    </div>
  )
}

/** The shell itself failed: the same message, as the page's main content. */
export function RootError() {
  return (
    <main id="main" className="app-main">
      <RouteError />
    </main>
  )
}
